export const formatCurrency = (cantidad) => {
    return cantidad?.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    })
}